import { getJSON } from '@folklore/fetch';

const locale = window.LOCALE || 'en';
const getLocaleHeaders = () =>
    locale !== null
        ? {
              'Accept-Language': locale,
          }
        : null;
export const loadPage = url =>
    getJSON(url, {
        credentials: 'same-origin',
        headers: {
            ...getLocaleHeaders(),
        },
    });
export const loadTwitter = () =>
    getJSON('/home.json', {
        credentials: 'same-origin',
        headers: {
            ...getLocaleHeaders(),
        },
    });
export const loadStoriesAndArticles = () =>
    getJSON('stories.json', {
        credentials: 'same-origin',
        headers: {
            ...getLocaleHeaders(),
        },
    });
export const loadCommunity = () =>
    getJSON('/community.json', {
        credentials: 'same-origin',
        headers: {
            ...getLocaleHeaders(),
        },
    });
export const loadScreenings = () =>
    getJSON('/screenings-and-news.json', {
        credentials: 'same-origin',
        headers: {
            ...getLocaleHeaders(),
        },
    });
export default {
    loadPage,
};
